function IconCaretUp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={21} height={10} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20.406 10L10.584 0 .6 10"
        stroke="currentColor"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default IconCaretUp;
